import React from "react";

const RestoreIcon = () => {
  return (
    <img
      alt="icon"
      src={process.env.PUBLIC_URL + "/img/restore.png"}
      width="24"
      height="24"
    />
  );
};

export default RestoreIcon;
